import * as React from "react";
import {useDispatch, useMappedState} from "redux-react-hook";
import {AuthAction} from "../store/actions/auth";

const useAuth = (history: any) => {
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const auth = useMappedState((state) => (state.auth))
  const redirect = React.useCallback(() => {
    history.push('/');
  }, [history]);


  if(token && auth.token === '') {
    dispatch({
      type: AuthAction.GET_CURRENT_USER,
      payload: {
        token,
        redirect
      }
    });
  }

  if(!token) {
    history.push('/auth/login')
  }
  return auth;
};

export default useAuth;
